import { render, staticRenderFns } from "./ApplianceTypeUpdate.vue?vue&type=template&id=38e9934d"
import script from "./ApplianceTypeUpdate.vue?vue&type=script&lang=js"
export * from "./ApplianceTypeUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports